












import { Component, Vue, Prop, Model } from 'vue-property-decorator';

import MultiSelect from './Multiselect.vue';

import { MultiSelect as MultiSelectInterface, MultiSelectValue } from '@/lib/formFactory/multiselect/interface';

let timeout: number | undefined;

const LOAD_DELAY = 200;

@Component({
    components: {
        MultiSelect,
    },
})
export default class MultiSelectEntity extends Vue {
    @Model('change', { required: true }) readonly selected!: MultiSelectValue[]
    @Prop() readonly data!: MultiSelectInterface;
    @Prop() readonly error!: string;

    get modelWrapper() {
        return this.selected;
    }

    set modelWrapper(selected) {
        this.$emit('change', selected);
    }

    get isAutocomplete() {
        return Boolean(this.data.listLoader);
    }

    quequeItemsLoad(query: string) {
        if (this.data.listLoader) {
            clearTimeout(timeout);

            timeout = setTimeout(() => {
                this.loadItems(query);
            }, LOAD_DELAY);
        }
    }

    loadItems(query = '') {
        this.data.listLoader?.load(query);        
    }

    created() {
        this.loadItems();
    }
}
